import React from 'react';
import { TableLoader } from './common/table-loader';
import { PageHeaderLoader } from './common/page-header-loader';
import { BoxLoader } from './common/box-loader';
import { CollapsibleSummaryLoader } from './common/collapsible-summary-loader';

export const OrderDetailsPageLoader = () => {
  return (
    <div className="pl-8">
      <PageHeaderLoader />
      <BoxLoader />
      <CollapsibleSummaryLoader />
      <br />
      <br />
      <TableLoader hideFilters hideActions columnsCount={3} />
      <br />
    </div>
  );
};
